import { useEffect, useRef } from "react";
import type { FamilyId } from "@/lib/odds-screen/live/types";

export function useResetOnFamilyChange(family: FamilyId | null, reset: () => void): void {
  const previous = useRef<FamilyId | null>(family);
  useEffect(() => {
    if (previous.current === family) return;
    previous.current = family;
    reset();
  }, [family, reset]);
}
